export default {
  // Title
  device: 'Device',

  // Device info
  noDrone: 'No drone',
}
